module.exports = __webpack_public_path__ + "img/aston-villa-logo-icon.a8410f35.png";